module.exports = __webpack_public_path__ + "static/efreeti_city_of_brass-084a8a7f0bc6591c9a5890b95c39ebb3.png";